var _rect, _text, _text2, _line, _path, _g, _g2, _g3, _g4, _g5, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3AFig4WhereDefectsWereCaught(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 500",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 500,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Where the two defects were caught")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Both were found by an independent review pass, in work the automated suite had already passed")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 290,
    x2: 1120,
    y2: 290,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1120 284 l12 6 l-12 6 z",
    fill: "#D4DDD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 14,
    fill: "#1A2F2A",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 290,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 325,
    textAnchor: "middle"
  }, "Read")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 290,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 325,
    textAnchor: "middle"
  }, "Decide")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 290,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 325,
    textAnchor: "middle"
  }, "Author")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 290,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 325,
    textAnchor: "middle"
  }, "Integrate")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 290,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 928,
    y: 325,
    textAnchor: "middle"
  }, "Audit")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1090,
    cy: 290,
    r: 7,
    fill: "#FFFFFF",
    stroke: "#D4DDD6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1090,
    y: 325,
    textAnchor: "middle"
  }, "Ship")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#16A34A"
  }, /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 352,
    textAnchor: "middle"
  }, "contract self-checks green"), /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 352,
    textAnchor: "middle"
  }, "full suite green, 4,181 checks"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 282,
    x2: 540,
    y2: 196,
    stroke: "#DC2626",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 290,
    r: 9,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 295,
    fontSize: 11,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontWeight: 700
  }, "1"), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 110,
    width: 296,
    height: 86,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 136,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Blind verifier, during authoring"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 156,
    fontSize: 12,
    fill: "#4A5F56"
  }, "the contract required a cross-framework name"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 172,
    fontSize: 12,
    fill: "#4A5F56"
  }, "that two of five patterns cannot have, and one"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 188,
    fontSize: 12,
    fill: "#4A5F56"
  }, "mapping the cited source contradicts"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 282,
    x2: 960,
    y2: 196,
    stroke: "#DC2626",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 290,
    r: 9,
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 295,
    fontSize: 11,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontWeight: 700
  }, "2"), /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 110,
    width: 296,
    height: 86,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 136,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Cold audit, after integration"), /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 156,
    fontSize: 12,
    fill: "#4A5F56"
  }, "intake rows shredded on commas inside the"), /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 172,
    fontSize: 12,
    fill: "#4A5F56"
  }, "buyer's frozen parameters; the test vector"), /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 188,
    fontSize: 12,
    fill: "#4A5F56"
  }, "happened to contain no commas"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#16A34A",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 420,
    textAnchor: "middle"
  }, "repaired by a targeted re-author,"), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 437,
    textAnchor: "middle"
  }, "re-reviewed, then passed"), /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 420,
    textAnchor: "middle"
  }, "repaired to structured table intake,"), /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 437,
    textAnchor: "middle"
  }, "re-gated green before the merge"), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 362,
    x2: 540,
    y2: 402,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 362,
    x2: 960,
    y2: 402,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 480,
    fontSize: 13,
    fill: "#6B7F74"
  }, "A green suite proves internal consistency with the committed reference; these two reviews test the contract against the source and against a buyer's real input.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3AFig4WhereDefectsWereCaught);
export default __webpack_public_path__ + "static/media/case3a-fig4-where-defects-were-caught.9b0a9f28fd9f91afdb91b0f88c5d7a47.svg";
export { ForwardRef as ReactComponent };